export default __webpack_public_path__ + "524631e286f0dd7ee39eda12e5416b98.svg";